import {getStore, setStore, removeStore} from '../../utils/storage.js'

const state = {
  name: getStore('userName') ? getStore('userName') : '',
  token: getStore('userToken') ? getStore('userToken') : '',
  password: getStore('userPassword') ? getStore('userPassword') : '',
  rememberPassword: Boolean(getStore('userRememberPassword')),
  roles: [],
  permissions: []
}

const mutations = {
  SET_NAME: (state, name) => {
    state.name = name
    setStore('userName', name)
  },
  SET_PASSWORD: (state, passwordOptions) => {
    if (passwordOptions.rememberPassword) {
      state.password = passwordOptions.password
      state.rememberPassword = true
      setStore('userPassword', passwordOptions.password)
      setStore('userRememberPassword', passwordOptions.rememberPassword.toString())
    } else {
      state.password = ''
      state.rememberPassword = false
      removeStore('userPassword')
      removeStore('userRememberPassword')
    }
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    setStore('userToken', token)
  },
  CLEAR: (state) => {
    state.name = ''
    state.password = ''
    state.rememberPassword = false
    state.token = ''

    removeStore('userName')
    removeStore('userPassword')
    removeStore('userRememberPassword')
    removeStore('userToken')
  }
}

const actions = {

}

const getters = {
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js